import { serviceDirectoryApiClient } from '@/services/service-directory';

class Captcha {
  verifyCaptcha = async (captchaToken: string) => {
    const response = await serviceDirectoryApiClient.post(`captcha-verify`, {
      captchaToken,
    });
    return response.status;
  };
}

export const CaptchaInstance = new Captcha();
